export default function FooterSection() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-[1400px] mx-auto px-8 md:px-12 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8 mb-16">
          <div className="w-8 h-8 rounded-full border-2 border-white/30 flex items-center justify-center shrink-0">
            <div className="w-2 h-2 rounded-full bg-white/50"></div>
          </div>
          <p className="text-sm text-white/50 max-w-md leading-relaxed lg:text-right">
            Professional engineering team focused on modern digital solutions for the iOS platform and related technologies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Engineering</h4>
            <div className="space-y-3">
              <p className="text-sm text-white/40">System Architecture</p>
              <p className="text-sm text-white/40">Performance Optimization</p>
              <p className="text-sm text-white/40">Scalable Infrastructure</p>
              <p className="text-sm text-white/40">Technical Consulting</p>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Development</h4>
            <div className="space-y-3">
              <p className="text-sm text-white/40">Clean Architecture</p>
              <p className="text-sm text-white/40">Modular Design</p>
              <p className="text-sm text-white/40">Quality Assurance</p>
              <p className="text-sm text-white/40">Continuous Improvement</p>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Standards</h4>
            <div className="space-y-3">
              <p className="text-sm text-white/40">Modern Practices</p>
              <p className="text-sm text-white/40">Code Quality</p>
              <p className="text-sm text-white/40">Security First</p>
              <p className="text-sm text-white/40">Documentation</p>
            </div>
          </div>

          <div className="lg:text-right">
            <p className="text-base text-white/50 leading-relaxed" style={{ fontFamily: "'Crimson Text', serif" }}>
              &copy; {new Date().getFullYear()} All rights reserved.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-16 border-t border-white/10">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-0">
            <div className="w-full lg:w-[30%] shrink-0">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20interior%20scene%20with%20geometric%20furniture%20forms%20soft%20ambient%20lighting%20in%20warm%20beige%20and%20cream%20tones%20minimalist%20modern%20space%20with%20organic%20shapes%20and%20clean%20lines%20no%20human%20figures%20calm%20serene%20atmosphere%20architectural%20photography&width=600&height=400&seq=analitikos-footer-01&orientation=landscape"
                  alt="Abstract minimalist interior with geometric forms and soft ambient lighting"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            <div className="w-full lg:w-[30%] flex items-center lg:pl-8">
              <div>
                <p className="text-2xl text-white/40 leading-[1.3]" style={{ fontFamily: "'Crimson Text', serif" }}>
                  Reliable
                </p>
                <p className="text-2xl text-white/40 leading-[1.3]" style={{ fontFamily: "'Crimson Text', serif" }}>
                  Maintainable
                </p>
                <p className="text-2xl text-white/40 leading-[1.3]" style={{ fontFamily: "'Crimson Text', serif" }}>
                  Systems
                </p>
              </div>
            </div>

            <div className="w-full lg:w-[40%] lg:pl-8">
              <div className="space-y-2 text-sm text-white/50 leading-relaxed">
                <p>J. Vienozinskio g. 70e</p>
                <p>Kaunas, LT-48462, Lithuania</p>
                <p className="mt-4">+370 66806313</p>
                <p>ceo@analitikossistemos.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}